import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";

const InscritosEventosSelector = (props) => {
  const [aluno, setAluno] = useState("");
  const [alunosOptions, setAlunosOptions] = useState([]);
  const [alunoSearch, setAlunoSearch] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      const text = options.find((option) => option.value === value).text;

      setAluno(value);
      setAlunoSearch(text);
    },
    [props]
  );

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;

    setAlunoSearch(search);

    api.get(`inscricoes-eventos-new?search=${search}`).then((res) => {
      if (res.data.items.length > 0) {
        const options = res.data.items.map((pessoa, index) => ({
          key: index,
          text: `${pessoa.nome.slice(0, 20)}${
            pessoa.nome.length > 20 ? "..." : ""
          } (${pessoa.email})  [Token: ${pessoa.id}]`,
          value: pessoa.id,
        }));
        setAlunosOptions(options);
        return;
      }
      setAlunosOptions([]);
    });
  });

  const initialLoad = useCallback(async () => {
    try {
      if (aluno) {
        return;
      }

      const id = props.initialValue;

      const alunoResponse = (
        await api.get(`inscricoes-eventos-new?search=${id}`)
      ).data.items[0];

      const newAlunosOptions = [
        {
          key: 0,
          text: `${alunoResponse.nome.slice(0, 20)}${
            alunoResponse.nome.length > 20 ? "..." : ""
          } (${alunoResponse.email}) [Token: ${alunoResponse.id}]`,
          value: alunoResponse.id,
        },
      ];

      setAlunosOptions(newAlunosOptions);
      setAluno(id);
    } catch (err) {
      console.error(err);
      return;
    }
  }, [props, aluno]);

  useEffect(() => {
    initialLoad();
  }, [props]);

  const handleChange = useCallback(() => {
    props.handleChange(aluno);
  }, [props, aluno]);

  useEffect(() => {
    handleChange();
  }, [aluno]);

  return (
    <Container>
      <div>
        <Label>Aluno / Parceiro</Label>
        <Dropdown
          placeholder="Busque pelo ID, Nome ou E-mail do aluno"
          fluid
          search
          selection
          options={alunosOptions}
          onChange={handleAlunoChange}
          searchQuery={alunoSearch}
          onSearchChange={handleAlunoSearchChange}
          value={aluno}
        />
      </div>
    </Container>
  );
};

export default InscritosEventosSelector;
